import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { MultiSelectModule } from 'primeng/multiselect';
import { sample } from 'rxjs';
import Detail from '../../../../../../types/detail/Detail';
import SampleCategory from '../../../../../../types/sample-category/SampleCategory';
import SampleType from '../../../../../../types/sample-type/SampleType';
import { FieldOfUse } from '../../../../../../types/sample/FieldOfUse';
import SampleFormat from '../../../../../../types/sample/SampleFormat';
import { SampleState } from '../../../../../../types/sample/SampleState';
import SelectOption from '../../../../../../types/shared/SelectOption';

@Component({
    selector: 'app-filter-samples-dialog',
    templateUrl: './filter-samples-dialog.component.html',
    styleUrls: [ './filter-samples-dialog.component.scss' ],
    imports: [
        FormsModule,
        MultiSelectModule,
        DialogModule,
        ButtonModule,
        IftaLabelModule,
    ]
})
export class FilterSamplesDialogComponent implements OnChanges {
    @Input() visible: boolean = false;
    @Input() public fieldOfUseOptions: SelectOption[] = [];
    @Input() public sampleTypeOptions: SampleType[] = [];
    @Input() public sampleStateOptions: SelectOption[] = [];
    @Input() public sampleCategoryOptions: SampleCategory[] = [];
    @Input() public sampleDetailOptions: Detail[] = [];
    @Input() public sampleFormatOptions: SelectOption[] = [];

    @Input() activeFilters: {
        fieldOfUse: FieldOfUse[],
        sampleType: SampleType[],
        sampleState: SampleState[],
        sampleCategory: SampleCategory[],
        sampleDetails: Detail[],
        format: SampleFormat[]
    } = {
        fieldOfUse: [],
        sampleType: [],
        sampleState: [],
        sampleCategory: [],
        sampleDetails: [],
        format: [],
    };

    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() filtersApplied: EventEmitter<any> = new EventEmitter<any>();

    public filters = {
        fieldOfUse: [] as FieldOfUse[],
        sampleType: [] as SampleType[],
        sampleState: [] as SampleState[],
        sampleCategory: [] as SampleCategory[],
        sampleDetails: [] as Detail[],
        format: [] as SampleFormat[],
    };

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['visible'] && this.visible) {
            this.filters = {
                ...this.activeFilters
            };
        }
    }

    constructor() {
    }

    public close(): void {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public resetFilters(): void {
        this.filters = {
            fieldOfUse: [],
            sampleType: [],
            sampleState: [],
            sampleCategory: [],
            sampleDetails: [],
            format: [],
        };
        this.applyFilters();
    }

    public applyFilters(): void {
        this.filtersApplied.emit(this.filters);
        this.close();
    }

    protected readonly sample = sample;
}
